<template>
  <Autosuggest
    v-bind="{
      value,
      label,
      minLength: 2,
      disabled: !country,
      displayProperty: 'text',
      placeholder: $t('_web_filter_enter-city', 'Start enter city'),
      tabindex,
      source: getCities,
    }"
    @resultPicked="$emit('input', $event)"
  />
</template>

<script>
import { mapActions } from 'vuex';
import { emptyObject, prop } from '@/utils/factories';
import Autosuggest from './HeraAutosuggest';

export default {
  components: {
    Autosuggest,
  },

  props: {
    value: {
      type: null,
      default: emptyObject,
    },
    label: prop(String),
    country: {
      type: null,
      required: true,
    },
    tabindex: prop(Number),
  },

  watch: {
    'country.id': function(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.$emit('input', null);
      }
    },
  },

  methods: {
    ...mapActions(['suggestCitiesRequest']),

    getCities(query) {
      return this.suggestCitiesRequest({
        countryId: this.country.id,
        query,
      });
    },
  },
};
</script>
